import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { environment } from 'src/environments/environment'

@Component({
    standalone: false,
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
    constructor(private router: Router) {
        if (environment.production) {
            this.router.navigateByUrl('/portal').catch((err) => {
                console.error(err)
            })
        }
    }

    ngOnInit() {}
}
